import ReactDOM from 'react-dom';
import { FC } from 'react';
import { ReactComponent as CloseSvg } from 'assets/img/close.svg';
import styles from './Modal.module.scss';
import classNames from 'classnames';

type ModalProps = {
  children: JSX.Element;
  open?: boolean;
  setOpen: (e: boolean) => void;
  className?: string;
  zIndex?: number;
};

export const Modal: FC<ModalProps> = ({ children, setOpen, className, zIndex }) => {
  const handleOverlayMouseDown = () => {
    setOpen(false);
  };

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return ReactDOM.createPortal(
    <div className={styles.root} style={{ zIndex }} onMouseDown={handleOverlayMouseDown}>
      <div className={styles.modal} onMouseDown={stopPropagation}>
        <div>{children}</div>
        <div
          className={classNames(styles.close, className)}
          onMouseDown={handleOverlayMouseDown}>
          <CloseSvg />
        </div>
      </div>
    </div>,
    document.body,
  );
};
